"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileItem = exports.Form = void 0;
var react_1 = __importDefault(require("react"));
var form_1 = require("remota-client/component/form");
var NUMBER_OF_MAXIMUM_FILES = 1;
// TODO: 画像D&D対応
var Form = function (props) {
    var useExternalMappingCsvUpload = props.useExternalMappingCsvUpload, useExternalMappingJobRun = props.useExternalMappingJobRun;
    var _a = __read(useExternalMappingJobRun(), 1), run = _a[0];
    var _b = __read(react_1.default.useState(null), 2), file = _b[0], setFile = _b[1];
    var handleFile = react_1.default.useCallback(function (file) {
        setFile({ file: file, isFinished: false });
    }, []);
    var handleFinish = react_1.default.useCallback(function (payload) {
        if (file) {
            setFile(null);
        }
        if (payload.info) {
            run(payload.info);
        }
    }, [file, run]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(form_1.File, { onFile: handleFile, accept: "text/csv", label: "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9", multiple: true, disabled: !!file, numberOfMaximumFiles: NUMBER_OF_MAXIMUM_FILES, shouldResetOnClick: true }),
        file ? (react_1.default.createElement(exports.FileItem, { file: file.file, onFinish: handleFinish, useExternalMappingCsvUpload: useExternalMappingCsvUpload })) : null));
};
exports.Form = Form;
var FileItem = function (props) {
    var file = props.file, onFinish = props.onFinish, useExternalMappingCsvUpload = props.useExternalMappingCsvUpload;
    var _a = __read(useExternalMappingCsvUpload(function (payload) {
        onFinish(payload);
    }), 1), upload = _a[0];
    react_1.default.useEffect(function () {
        upload(file);
    }, [file, upload]);
    return null;
};
exports.FileItem = FileItem;
